var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 128,
    viewBox: "0 0 140 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.542 0c-10.349 0-18.93 7.992-19.687 18.256h9.087c8.328 0 15.226 6.815 15.226 15.23v5.552c8.667-2.103 15.23-9.928 15.23-19.266C94.398 8.832 85.478 0 74.542 0zM51.74 48.629H39.627v30.54h-6.142V48.63h-12.2v-5.973H51.74v5.973zm12.201-24.314H9.17c-5.047 0-9.17 4.123-9.17 9.17v54.773c0 5.046 4.123 9.17 9.17 9.17h54.772c5.048 0 9.086-4.124 9.086-9.17V33.486c0-5.048-4.038-9.17-9.086-9.17zM79.17 48.63v39.628c0 8.413-6.899 15.144-15.227 15.144H46.273c1.178 6.057 4.207 11.358 8.33 15.565 5.469 5.469 13.125 8.834 21.538 8.834 16.743 0 30.372-13.63 30.372-30.372v-48.8H79.169zm41.059-36.43c-7.572 0-13.714 6.142-13.714 13.715 0 7.487 6.142 13.712 13.714 13.712 7.488 0 13.715-6.225 13.715-13.712 0-7.573-6.227-13.714-13.715-13.714zm-7.657 36.43v48.799c0 2.44-.253 4.879-.673 7.15 2.524 1.262 5.384 1.936 8.329 1.936 10.938 0 19.773-8.835 19.773-19.772V48.63h-27.429z",
    fill: "#E5E3E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsMessage);
export default __webpack_public_path__ + "static/media/teams-message.8e8789e24dc57125a064a32748caee42.svg";
export { ForwardRef as ReactComponent };